import classNames from 'classnames'
import { CSSProperties, PropsWithChildren } from 'react'

import { useSensitiveData } from '@context/SensitiveDataContext'

import styles from './SensitiveData.module.scss'

interface SensitiveDataProps {
  style?: CSSProperties
}
export const SensitiveData: React.FC<PropsWithChildren<SensitiveDataProps>> = ({
  children,
  style,
}) => {
  const sensitiveDataFlag = useSensitiveData()

  return (
    <span style={style} className={classNames({ [styles.blurSensitive]: sensitiveDataFlag })}>
      {children}
    </span>
  )
}
